import { render, staticRenderFns } from "./FeedbackSubjectCreate.vue?vue&type=template&id=285aae66&lang=pug"
import script from "./FeedbackSubjectCreate.vue?vue&type=script&lang=js"
export * from "./FeedbackSubjectCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports